import { createFileRoute } from "@tanstack/react-router";
import PartnerPortal from "@/pages/PartnerPortal";

export const Route = createFileRoute("/en/partners")({
  head: () => ({
    meta: [
      { title: "Partner portal | Retail Lemon" },
      { name: "description", content: "Private access for professionals approved by Retail Lemon." },
      { property: "og:title", content: "Partner portal | Retail Lemon" },
      { property: "og:description", content: "Private access for professionals approved by Retail Lemon." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: PartnerPortal,
});
